import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getAssetByParentId } from '../../../api/api';

const getRelationshipType = field => {
  const { opts } = field || {};

  const { relationshipType } = opts || {};

  return relationshipType;
}

const getRelationshipField = field => {
  const { opts } = field || {};

  const { relationshipField } = opts || {};

  return relationshipField;
}

export default class RelationshipCell extends Component {
  constructor(props) {
    super(props);
    this.loadValue = this.loadValue.bind(this);
    this.state = { relationship: null };
  }
  componentDidMount() {
    const { value } = this.props;

    if (!value) return;
    
    this.loadValue();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.value === this.props.value) return;

    this.loadValue();
  }
  async loadValue() {
    const type = getRelationshipType(this.props.field);
    const { value } = this.props || {};
    if (!value) return;

    try {
      const relationship = await getAssetByParentId({ id: value, type });
      this.setState({ relationship });
    } catch (err) {
      // TODO handle error
    }
  }
  render() {
    const { value, field } = this.props;
    const { relationship } = this.state;
    const relationshipField = getRelationshipField(field);
    
    return (
      <div>
        {relationship && (
          <Link
            target="_blank"
            to={`/pages/${getRelationshipType(field)}/${encodeURIComponent(relationship._id)}`}
          >
            {(relationship.data || {})[relationshipField]}
          </Link>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/routes/assets/RelationshipCell.js